import React, { Component } from "react";
import { matchPath, Link } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Spinner from "../../lib/spinner";
import ExpandableText from "../../lib/expandable_text/expandable_text";
import ProgressBar from "../../lib/progress_bar";
import ContextMenu from "../../lib/context_menu";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { getMegapodURL } from "../../../lib/config";
import { getImportJob, getImportJobDetail } from "../../../lib/import_jobs_helper";
import WarningPanel from "../../lib/warning_panel";
import { If } from "react-extras";
import { distributionKeys } from "../../../constants/distribution";
import { CATEGORIES, ACTIONS, gtagEvent } from "../../../lib/google_analytics";
import { Helmet } from "react-helmet";
import { createTitle } from "../../../lib/strings";
import Divider from "../../lib/divider";
import ClipboardJS from "clipboard";
import ShowPageWrapper from "./show_page_wrapper";
import StatsWidgetContainerWrapper from "../../lib/stats/stats_widget_container_wrapper";
import { ShowPageNav } from "../../lib/show_page_nav/show_page_nav";
import { displayAdvertisingNotification } from "../../../lib/user_attribute";

class ShowDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.getShowUUID = this.getShowUUID.bind(this);
  }

  componentDidMount() {
    if (this.getShowUUID()) {
      this.props.fetchShow(this.getShowUUID(), this.props.user);
      this.startPoll();
      this.getImportJobs();
      this.props.fetchDistributions(this.getShowUUID());
      this.props.fetchEpisodesForShow(this.getShowUUID());
    }
    this.clipboard = new ClipboardJS(".clipboard-js");
    this.clipboard.on("success", () => this.props.showSuccess("Copied to clipboard."));
  }

  getImportJobs = () => {
    this.props.fetchJobsForUser(this.props.user);
  };

  startPoll = () => {
    if (!this.timeout) {
      this.timeout = setInterval(this.getImportJobs, 5000);
    }
  };

  componentWillUnmount() {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  }

  getJobDetails = () => {
    const show = this.getShow();
    const importJob = getImportJob(this.props.importJobs, show);
    return getImportJobDetail(importJob, this.getShow());
  };

  showProgressBar = () => {
    const show = this.getShow();
    const details = this.getJobDetails();
    if (!details.shouldShowProgressBar) return false;

    return (
      <div className="show-details-progress-bar">
        <ProgressBar
          title={`Importing and Processing ${show.title}`}
          current={details.numEpisodesImported}
          total={details.totalJobs}
        />
      </div>
    );
  };

  getShow = () => {
    return get(this.props, ["shows", this.getShowUUID()]);
  };

  analyticsPanel = () => {
    return (
      <Row>
        <Col xs={12}>
          <StatsWidgetContainerWrapper uuid={this.getShowUUID()} uuidType={"showUUID"} />
        </Col>
      </Row>
    );
  };
  showPageNavs = isShowVerified => {
    if (this.getShow().isDemo) return null;
    const tooltipMessage =
      "This feature will become available when the redirect is complete or your first episode is published.";
    return (
      <Row>
        <ShowPageNav
          data-cy={"goto-episodes"}
          title={"Episodes"}
          to={`/shows/${this.getShowUUID()}/ep`}
          subtitle={"Manage, add, and edit episodes for your podcast"}
        />
        <>
          <ShowPageNav
            disabledTooltipMessage={tooltipMessage}
            title={"Distribution"}
            to={`/shows/${this.getShowUUID()}/distribution`}
            subtitle={"List your podcast on Apple Podcasts, Spotify, and more"}
            disabled={!isShowVerified}
          />
          <ShowPageNav
            disabledTooltipMessage={tooltipMessage}
            disabled={!isShowVerified}
            title={"Exclusive Content"}
            to={`/shows/${this.getShowUUID()}/i/exclusive-content`}
            subtitle={"Allow listeners to get access to your exclusive content"}
          />
          <ShowPageNav
            disabledTooltipMessage={tooltipMessage}
            disabled={!isShowVerified}
            title={"Donations"}
            to={`/shows/${this.getShowUUID()}/i/donations`}
            subtitle={"Allow listeners to donate one-time or monthly"}
          />

          <ShowPageNav
            disabledTooltipMessage={tooltipMessage}
            disabled={!isShowVerified}
            title={"Analytics"}
            to={`/stats?showUUID=${this.getShowUUID()}`}
            subtitle={"View analytics about this podcast and its episodes"}
          />
        </>
        <ShowPageNav
          disabledTooltipMessage={tooltipMessage}
          disabled={!isShowVerified}
          notification={displayAdvertisingNotification(
            this.getShow(),
            this.props.user,
            this.props.campaignItems
          )}
          title="Advertising"
          to={`/shows/${this.getShowUUID()}/advertising`}
          subtitle="View advertising offers that you've received for this podcast"
        />
      </Row>
    );
  };

  getDemoImportButton = () => {
    if (!this.getShow().isDemo) return null;
    return (
      <Row className={"m-tm"}>
        <Col xs={12} md={6} mdOffset={3} className={"text-center"}>
          <button
            className="btn btn-primary width-100"
            onClick={() =>
              this.props
                .submitEpisodesFeedImport(this.getShow().uuid, this.getShow().importedURL, 128)
                .then(
                  resp =>
                    resp.status === 200 && this.props.fetchShow(this.getShowUUID(), this.props.user)
                )
            }>
            Import My Show
          </button>
        </Col>
      </Row>
    );
  };

  render() {
    var show = this.getShow();
    var progressBar = this.showProgressBar();
    const showTitle = get(show, "title");

    const showID = get(show, "alias", get(show, "uuid"));
    const isShowVerified =
      show &&
      (isEmpty(show.importedURL) || show.redirectVerified === true) &&
      this.getNumEpisodes() > 0 &&
      !this.getJobDetails().shouldShowProgressBar;
    const publicURL = getMegapodURL() + "shows/" + showID;

    const publicLink = (
      <div
        className="show-page__additional-fields__web-player pointer fake-link clipboard-js"
        data-clipboard-text={publicURL}>
        Public Podcast Page
      </div>
    );
    const isDemo = (this.getShow() ?? {}).isDemo;
    return (
      <div className="show-details-page-container">
        <ShowPageWrapper
          preHeader={() => (
            <Row>
              <Col xs={12} md={12}>
                {this.redirectWarningPanel()}
                {progressBar}
                {!progressBar && this.distributionWarningPanel()}
              </Col>
            </Row>
          )}
          postBody={this.analyticsPanel}
          show={this.getShow()}
          backLink={"/shows"}
          title={get(this.getShow(), "title")}
          rightLink={() => (
            <If condition={!isDemo}>
              <ContextMenu
                noCircle={true}
                menuItems={{
                  "Podcast Settings": () => {
                    this.props.history.push(`/shows/${show.uuid}/edit`);
                  },
                  "Delete Podcast": () => {
                    this.props.showShowDeleteModal(this.getShowUUID());
                  },
                }}
              />
            </If>
          )}>
          <Helmet>
            <title>{createTitle(showTitle)}</title>
          </Helmet>
          <Spinner isLoading={this.props.isLoading} />
          {!this.props.isLoading && show && (
            <Grid fluid>
              <Row>
                <Col xs={12} md={12} className="show-details__title_bar">
                  <div className="show-details-summary limit-images">
                    <ExpandableText dangerousText={show.description} heightToWidth={4} />
                  </div>
                  <If condition={!isDemo}>
                    <div className="show-page__additional-fields subtext">
                      <If condition={isShowVerified}>{publicLink}</If>
                      <div
                        className="show-page__additional-fields__rss-feed-url pointer fake-link clipboard-js"
                        data-clipboard-text={show.rssURL}>
                        RSS Feed
                      </div>
                    </div>
                  </If>
                </Col>
              </Row>
              <If condition={!isDemo}>
                <Row>
                  <Col xs={12} md={12}>
                    <Divider smallMargin />
                  </Col>
                </Row>
              </If>
              {this.showPageNavs(isShowVerified)}
              {this.getDemoImportButton()}
            </Grid>
          )}
        </ShowPageWrapper>
      </div>
    );
  }

  getNumEpisodes = () => {
    const showUUID = this.getShowUUID();
    var episodes = this.props.episodesByShow?.[showUUID]?.episodes;
    if (!episodes) return 0;
    return Object.keys(episodes).length;
  };

  getShowUUID() {
    var result = matchPath(this.props.location.pathname, "/shows/:showUUID");
    return result && result.params && result.params.showUUID;
  }

  distributionWarningPanel = () => {
    var showUUID = this.getShowUUID();
    var distributions = get(this.props.distributions, showUUID, {});
    var hasMissingKeys = distributionKeys.some(
      item => !distributions[item.key] && !item.skipValidation
    );
    const numEpisodes = this.getNumEpisodes();
    var shouldShowPanel = hasMissingKeys && !this.shouldShowRedirectWarning() && numEpisodes > 0;
    return (
      <If condition={shouldShowPanel}>
        <WarningPanel>
          Your podcast may not yet be distributed to the major platforms.{" "}
          <Link to={`/shows/${showUUID}/distribution`}>Set Up Distribution</Link>
        </WarningPanel>
      </If>
    );
  };

  redirectWarningPanel = () => {
    if (!this.shouldShowRedirectWarning()) {
      return null;
    }
    const show = this.props.shows[this.getShowUUID()];
    return (
      <WarningPanel>
        Your import was successful. To complete the switch,{" "}
        <Link
          to={`/shows/${show.uuid}/redirect-help`}
          className="btn-link"
          onClick={() => gtagEvent(ACTIONS.CLICK, CATEGORIES.VERIFY_REDIRECT_LINK)}>
          redirect your podcast
        </Link>
      </WarningPanel>
    );
  };

  shouldShowRedirectWarning = () => {
    const details = this.getJobDetails();
    if (details.shouldShowProgressBar || !details.hasJobStarted) return false;

    const redirectVerified = get(this.getShow(), "redirectVerified", false);
    return !this.props.user || !redirectVerified;
  };
}

export default ShowDetailsPage;
